import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import  * as CMSActions  from "./store/actions";
import TopMenu from './TopMenu';
import LeftMenu from './LeftMenu'
import useMediaQuery from "app/hooks/useMediaQuery";

function AppMenu(props) {
    const dispatch = useDispatch();    
    const [options, setOptions] = useState([]);   
    const is4K = useMediaQuery('(min-width: 3840px)');
    const isDesktop = useMediaQuery('(min-width: 1280px)');
    const isTablet = useMediaQuery('(min-width: 768px)');

    const {contentMenu} = useSelector(        
        ({mainMenu}) => mainMenu.mainMenu
    )
    useEffect(() => {
        !contentMenu &&
        dispatch(CMSActions.getMainMenu());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    
    useEffect(() => {       
        if(contentMenu){
            setOptions(contentMenu?.secciondeMenu[0]?.seccionSitio?.contentItems);
        }
    },[contentMenu]);  
    
    return (
        isDesktop ? 
            <div className={`${is4K && "offcanvas-4K"}`} >
                <TopMenu name="TopMenu" options={options}/>
            </div>
        : isTablet ? 
            <LeftMenu name="LeftMenu" type="tablet" menuOptions={options}/>
        :
            <LeftMenu name="LeftMenu" type="mobile" menuOptions={options}/>
        
    );
}

export default AppMenu;